import { AssistentItem } from './assistent_config';
import { DataService } from '../../../services/data_service';
import { getAssistentConfigKonfig } from './items/assistent_config_config';
import { getAssistentConfigWaerme } from './items/assistent_config_waerme';
import { getAssistentConfigKraftstoffe } from './items/assistent_config_kraftstoffe';
import { getAssistentConfigStandorte } from './items/assistent_config_standorte';
import { getAssistentConfigCO2 } from './items/assistent_config_co2';
import { getAssistentConfigStrom, getAssistentConfigEigenStrom } from './items/assistent_config_strom';
import { getAssistentConfigUnternehmen } from './items/assistent_config_unternehmensdaten';
import { getAssistentConfigVsmeBasisItems } from './items/assistent_config_vsme_basis';
import { getAssistentConfigVsmeBpmItems } from './items/assistent_config_vsme_bpm';
import { getAssistentConfigVsmePatItems } from './items/assistent_config_vsme_pat';
import { IDs } from '../../../helpers/IDs';
import { isEnableErneuerbareEnergien, isEnableStandorte } from './assistent_helpers';
import { StructureService } from '../../../services/structure_service';
import { TriggerService } from '../../../core/trigger/trigger_service';

export function getAssistentConfigVsme(
    standort: any, data: any, jahr: number, dataService: DataService, triggerService: TriggerService, structureService: StructureService,
    onRoutingChange: (routing: any) => void, clearPruefState: () => void, isAdmin: boolean, bereichKey: string, routing: any
) {
    standort = standort || {};
    const config: AssistentItem[] = [];
    const konfiguration: any[] = data[IDs.ENT_KONFIGURATION] || [];

   /* const b1: any = ((data || {})[IDs.ENT_VSME_B1] || [])
        .find((item: any) => (item.standort_tid_orig || item.standort_tid) === standort.tid) || {};
    const b3: any = ((data || {})[IDs.ENT_VSME_B3] || [])
        .find((item: any) => (item.standort_tid_orig || item.standort_tid) === standort.tid) || {};
    const includePatModul = Object.keys(b1).length ? (b1.modul === 'basis_pat' || b1.modul === 'basis_pat_geschaeft') : true;
    const includeBpmModul = Object.keys(b1).length ? (b1.modul === 'basis_geschaeft' || b1.modul === 'basis_pat_geschaeft') : true;
    const useB3Group: boolean = b3.e_tool_nutzung_orig !== 2; // {1} Ja, {2} Nein
    const isKonsolidiert: boolean = b1.bericht === 'konsolidiert';*/
    const vsmeStructures = [
        ...getAssistentConfigVsmeBasisItems(data, triggerService, structureService) /*,
        ...(includePatModul ? getAssistentConfigVsmePatItems(standort, data, jahr, triggerService, structureService) : []),
        ...(includeBpmModul ? getAssistentConfigVsmeBpmItems(standort, data, jahr, triggerService, structureService) : []),
        */
    ];
    (vsmeStructures || []).forEach((struc: any) => {
        
        if (struc.entity && struc.group !== 'vsme_basis') {
                config.push(struc);
        } else {
            config.push(struc);
        }
        
    });

    return config;
}

function checkVSMEAuswahl(data: any, standortTid: number, jahr: number, struc: any) {
    const fnd = (data[IDs.ENT_VSME_AUSWAHL] || [])
        .find((r: any) => r.standort_tid_orig === standortTid && r.jahr === jahr && r.name === struc.entity && r.category === struc.group);
    if (fnd && fnd.auswahl === 1) {
        return true;
    }
    return false;
}

export function getVSMEAuswahl(data: any, standortTid: number, jahr?: number, jahrVon?: number, jahrBis?: number, group?: string) {
    const auswahl = (data[IDs.ENT_VSME_AUSWAHL] || [])
        .filter((r: any) =>
            r.standort_tid_orig === standortTid
            && (jahr > 0 ? r.jahr === jahr : true)
            && (jahrVon > 0 && jahrBis > 0 ? r.jahr >= jahrVon && r.jahr <= jahrBis : true)
            && (group ? r.category === group : true)
            && r.auswahl === 1
        )
        .map((r: any) => r.name)
        .filter((key: string, idx: number, self: string[]) => self.indexOf(key) === idx)
        .sort();
    return auswahl;
}

